module.exports = __webpack_public_path__ + "img/login-office.72742c2e.jpeg";